export const JOKER_RANK = 13;
export const MIN_NUMBERED_RANK = 1;
export const MAX_NUMBERED_RANK = 12;
export function buildDeck() {
    const deck = [];
    let id = 0;
    for (let rank = MIN_NUMBERED_RANK; rank <= MAX_NUMBERED_RANK; rank++) {
        for (let i = 0; i < rank; i++) {
            deck.push({ id: id++, rank });
        }
    }
    deck.push({ id: id++, rank: JOKER_RANK });
    deck.push({ id: id++, rank: JOKER_RANK });
    return deck;
}
export function isJoker(card) {
    return card.rank === JOKER_RANK;
}
export const DECK_SIZE = 80;
